<style scoped lang="scss" type="text/scss">
    .ticket-container {
        background-color: rgba(0, 0, 0, .15);
        border-left: .3rem solid #666;
        padding-left: .5rem;
        display: flex;
        height: 2.5rem;
        line-height: 2rem;
        align-items: center;
        border-top-right-radius: .15rem;
        border-bottom-right-radius: .15rem;
        font-size: .85rem;
        color: #888;

        &.student {
            background-color: rgba(63, 158, 255, .15);
            border-left-color: #3F9EFF;
            color: #3F9EFF;
            .delete-container:before {
                background-color: rgba(63, 158, 255, .3);
            }
        }
        &.teacher {
            background-color: rgba(146, 26, 255, .15);
            border-left-color: #921AFF;
            color: #921AFF;
            .delete-container:before {
                background-color: rgba(146, 26, 255, .3);
            }
        }

        .gender-block {
            margin-left: .3rem;
        }

        .icon {
            &.delete {
                &:hover {
                    transition: all .2s;
                    cursor: pointer;
                    color: #FF3333;
                }
            }
        }
        .text {
            flex: 1;
            width: 5rem;
            text-align: center;
            font-weight: bold;
            margin: 0 .5rem;
        }
        .delete-container {
            width: 1.5rem;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                left: 0;
                height: 60%;
                width: 1px;
                top: 20%;
                background-color: rgba(100, 100, 100, .3);
            }
        }
    }
</style>

<template>
    <div class="ticket-container" :class="{'teacher': isTeacher, 'student': isStudent}">
        <rectangular-text :bg-color='roleColor'>{{ roleText }}</rectangular-text>
        <rectangular-text :bg-color='roleColor' class="gender-block">
            <i class="icon" v-html="genderIcon"></i>
        </rectangular-text>
        <span class="text global-text-ellipsis">
            <slot></slot>
        </span>
        <div class="delete-container" v-if="deletable === true">
            <i class="icon delete" @click="remove">&#xe63e;</i>
        </div>
    </div>
</template>

<script>
    import {GENDER_VALUE_MAP} from '../../constant/gender';
    import RectangularText from '../rectangular-text/index';
    import {ROLE_VALUE_MAP} from '../../constant/role';

    export default {
        name: '',
        components: {
            RectangularText
        },
        props: {
            gender: {
                type: Number,
                default: null
            },
            role: {
                type: Number,
                default: null
            },
            deletable: {
                type: Boolean,
                default: null
            }
        },
        data () {
            return {};
        },
        computed: {
            isTeacher () {
                return this.role === ROLE_VALUE_MAP.TEACHER;
            },
            isStudent () {
                return this.role === ROLE_VALUE_MAP.STUDENT;
            },
            genderIcon () {
                let icon = '&#xe689;';
                if (this.gender === GENDER_VALUE_MAP.FEMALE) {
                    icon = '&#xe6ba;';
                } else if (this.gender === GENDER_VALUE_MAP.MALE) {
                    icon = '&#xe664;';
                }
                return icon;
            },
            roleColor () {
                let color = '#666';
                if (this.isTeacher) {
                    color = '#C25AFF';
                } else if (this.isStudent) {
                    color = '#63AFFF';
                }
                return color;
            },
            roleText () {
                let text = '无';
                if (this.isTeacher) {
                    text = '师';
                } else if (this.isStudent) {
                    text = '学';
                }
                return text;
            }
        },
        methods: {
            remove () {
                this.$emit('remove');
            }
        }
    };
</script>
